// @flow

import { ReducerRegistry } from "../../../base/redux";
import { FEATURE_CUSTOM_REDUX_V2 } from "../../constant"

import {
    SET_AUDIO_CHANNEL,
    SET_AUDIO_CHANNEL_ADDITIONAL,
    SET_AUDIO_STEREO,
    SET_CIRCLE_PAN_CHANGE,
    SET_DELAY_LOCAL_CHANGE,
    SET_DEVICE_USER_NAME,
    SET_ORGANIZATION,
    SET_ORGANIZATION_LIST,
    SET_RECORDING_TYPE,
    SET_WHITEBOARD_ASSETS,
    SET_WHITEBOARD_CATEGORIES,
    SET_BUFFER_CHANGE_USER,
    SET_IS_BUFFER_CHANGE,
    SET_IS_DEVICE_LISTED,
    SET_TRANSLATE_MESSAGE,
    SET_MUTE_SPEAKING,
    SET_IS_RECORDING_LOADER,
    SET_RECORDING_TIMER,
    SET_IS_BUFFER_HOST_READY,
    SET_SCREEN_VIEW,
    SET_APP_BASE_CONFIG,
    SET_DEVICE_CONTAINER_STATUS,
    SET_RECORDING_MODAL_COUNT,
    SET_RECORDING_MODAL_ACTION,
    SET_RECORDING_EMAIL,
    SET_CHORD_DATA,
    SET_CHORD_IMG,
    SET_SHOW_UPLOAD_MODAL,
    SET_SHOW_RECORDING_MODAL,
    SET_PAID_ROOM_DETAIL,
    SET_STRIPE_ACCOUNT_CREATED,
    SET_STRIPE_ACCOUNT_VERIFIED,
    SET_TOOLS_OBJECT,
    SET_USERS_LIST_ARRAY,
    SET_IS_MY_RECORDINGS_MODAL,
    SET_MY_RECORDINGS_DATA,
    TOGGLE_LIGHTING_MENU_VISIBILITY,
    SET_ENABLE_RECORDING_MODAL,
    SET_ENABLE_WEBJAM_MODAL,
    SET_DISABLE_REC_ICON,
    SET_SHOW_CONNECT_POPUP,
    SET_STRIPE_ACCOUNT_REQUEST,
    SET_DUET_USER_ID,
    SET_STATE_MODEL,
    SET_PREJOIN_SCREEN_DEVICE_INIT,
    SET_THIRD_PARTY_MOD_EVENT,
    SET_DO_HANG_UP,
    SET_DEVICE_INFO_MESSAGE,
    SET_PREJOIN_ROOM_RT,
    SET_HOST_BUTTON_ACTION,
    SET_OUT_AUTO_MANAGE,
    SET_REG_DEVICES,
    SET_AVAILABLE_USER_IP,
    SET_CUSTOM_TOUR_ACTION,
    SET_DETECT_DEVICE_TIMER,
    SET_JOIN_WITHOUT_DEVICE,
    SET_BROWSER_DEVICE_STATUS,
    SET_PREJOIN_SCREEN_STEP_FLAG,
    SET_MEDIA_DEVICE_OVERLAY,
    SET_PREJOIN_SOCK_WAIT,
    SET_DEVICE_DETECTING,
    SET_PREJOIN_DEVICE_MESSAGE,
    SET_ZENDESK_STATE,
    SET_MIXER_SETTINGS
} from './actionType';

ReducerRegistry.register(FEATURE_CUSTOM_REDUX_V2, (state = {
    audioChannelConfig: 0,
    additionalChannelSetting: false,
    delayLocalChange: false,
    isStereoChanged: false,
    isStereoChanged: false,
    authOrganization: '',
    organizationList: [],
    whiteboardAssets: [],
    whiteboardCategories: [],
    chordData: {},
    chordImg: [],
    defaultRecordingType: "JIBRI",
    deviceUserName: '',
    isCirclePanChange: "",
    bufferChangeUser: "",
    isBufferChange: false,
    isDeviceListed: false,
    chatTranslateMessage: "",
    chatTranslateMessageSend: false,
    speakingWhileMute: "",
    isRecordingLoader: false,
    recordingTimer: 0,
    isBufferHostReady: false,
    screenview: "",
    appBaseWebConfig: "",
    deviceContainerStatus: '',
    recordingModalCount: 0,
    recordingModalAction: '',
    recordingEmail: '',
    showRecordingModal: '',
    showUploadModal: false,
    paidRoomDetail: {
        passwordProtected: false,
        isRoomPaid: false,
        time: "",
        isUserMadePayment: false,
        isRoomStarted: false
    },
    isStripeConnect: false,
    toolsObject: {},
    usersListArray: [],
    isStripeConnectVerified: "",
    isMyRecordingsModal: false,
    lightingMenuVisibility: false,
    enableRecordingModal: "",
    enableWebjamModal: false,
    disableRecIcon: false,
    showConnectPopup: true,
    isStripeRequesting: false,
    duetUserId: '',
    toolModal: {
        toolName: "",
        toolType: "",
        componentName: ""
    },
    prejoinDeviceConnection: "",
    thirdPartyModEvent: "",
    doHangUpRec: false,
    deviceInfoMessages: {
        show: false,
        messages: null
    },
    prejoinScreenDetail: {
        isSet: false,
        roomname: "",
        uniqueId: ""
    },
    remoteDeviceId: "",
    hostButtonAction: '',
    outAutoManage: true,
    registeredDevice: [],
    availableUserIp: [],
    allUserDevices: [],
    customTourAction: false,
    detectDeviceTimer: "",
    joinRoomWithoutDevice: false,
    browserDeviceStatus: {
        audio: {
            status: false,
            infoCode: ""
        },
        video: {
            status: false,
            infoCode: ""
        }
    },
    prejoinStepFlag: "",
    mediaDeviceOverlay: false,
    socketDeviceWaiting: false,
    isUserDeviceDetecting: false,
    isZendeskOpen: false,
    isShowMixerSettings: false,
    recordingInitiator: ""
}, action) => {
    switch (action.type) {
        case SET_AUDIO_CHANNEL:
            return {
                ...state,
                audioChannelConfig: action.audioChannelConfig,
            }
        case SET_AUDIO_CHANNEL_ADDITIONAL:
            return {
                ...state,
                additionalChannelSetting: action?.additionalChannelSetting
            }
        case SET_DELAY_LOCAL_CHANGE:
            return {
                ...state,
                delayLocalChange: action.delayLocalChange
            }
        case SET_AUDIO_STEREO:
            return {
                ...state,
                isStereoChanged: action.isStereoChanged
            }
        case SET_ORGANIZATION:
            return {
                ...state,
                authOrganization: action.authOrganization
            }
        case SET_ORGANIZATION_LIST:
            return {
                ...state,
                organizationList: action.organizationList
            }
        case SET_WHITEBOARD_ASSETS:
            return {
                ...state,
                whiteboardAssets: action.whiteboardAssets
            }
        case SET_WHITEBOARD_CATEGORIES:
            return {
                ...state,
                whiteboardCategories: action.whiteboardCategories
            }
        case SET_CHORD_DATA:
            return {
                ...state,
                chordData: action.chordData
            }
        case SET_CHORD_IMG:
            return {
                ...state,
                chordImg: action.chordImg
            }
        case SET_RECORDING_TYPE:
            return {
                ...state,
                defaultRecordingType: action.defaultRecordingType
            }
        case SET_DEVICE_USER_NAME:
            return {
                ...state,
                deviceUserName: action.deviceUserName
            }
        case SET_CIRCLE_PAN_CHANGE:
            return {
                ...state,
                isCirclePanChange: action.isCirclePanChange
            }
        case SET_BUFFER_CHANGE_USER:
            return {
                ...state,
                bufferChangeUser: action.bufferChangeUser
            }
        case SET_IS_BUFFER_CHANGE:
            return {
                ...state,
                isBufferChange: action.isBufferChange
            }
        case SET_IS_DEVICE_LISTED:
            return {
                ...state,
                isDeviceListed: action.isDeviceListed
            }
        case SET_TRANSLATE_MESSAGE: {
            return {
                ...state,
                chatTranslateMessage: action.chatTranslateMessage,
                chatTranslateMessageSend: action.chatTranslateMessageSend
            }
        }
        case SET_MUTE_SPEAKING: {
            return {
                ...state,
                speakingWhileMute: action.speakingWhileMute
            }
        }
        case SET_IS_RECORDING_LOADER:
            return {
                ...state,
                isRecordingLoader: action.isRecordingLoader
            }
        case SET_RECORDING_TIMER:
            return {
                ...state,
                recordingTimer: action.recordingTimer
            }
        case SET_IS_BUFFER_HOST_READY:
            return {
                ...state,
                isBufferHostReady: action.isBufferHostReady
            }
        case SET_SCREEN_VIEW:
            return {
                ...state,
                screenview: action.screenview
            }
        case SET_APP_BASE_CONFIG:
            return {
                ...state,
                appBaseWebConfig: action.appBaseWebConfig
            }
        case SET_DEVICE_CONTAINER_STATUS:
            return {
                ...state,
                deviceContainerStatus: action.deviceContainerStatus,
            }
        case SET_RECORDING_MODAL_COUNT:
            return {
                ...state,
                recordingModalCount: action.recordingModalCount
            }
        case SET_RECORDING_MODAL_ACTION:
            return {
                ...state,
                recordingModalAction: action.recordingModalAction
            }
        case SET_RECORDING_EMAIL:
            return {
                ...state,
                recordingEmail: action.recordingEmail
            }
        case SET_SHOW_RECORDING_MODAL:
            return {
                ...state,
                showRecordingModal: action.showRecordingModal
            }
        case SET_SHOW_UPLOAD_MODAL:
            return {
                ...state,
                showUploadModal: action.showUploadModal
            }
        case SET_PAID_ROOM_DETAIL:
            return {
                ...state,
                paidRoomDetail: action.paidRoomDetail
            }
        case SET_STRIPE_ACCOUNT_CREATED:
            return {
                ...state,
                isStripeConnect: action.isStripeConnect
            }
        case SET_STRIPE_ACCOUNT_VERIFIED:
            return {
                ...state,
                isStripeConnectVerified: action.isStripeConnectVerified
            }
        case SET_TOOLS_OBJECT:
            return {
                ...state,
                toolsObject: action.toolsObject
            }
        case SET_USERS_LIST_ARRAY:
            return {
                ...state,
                usersListArray: action.usersListArray
            }
        case SET_IS_MY_RECORDINGS_MODAL:
            return {
                ...state,
                isMyRecordingsModal: action.isMyRecordingsModal
            }
        case SET_MY_RECORDINGS_DATA:
            return {
                ...state,
                myRecordingsData: action.myRecordingsData
            }
        case TOGGLE_LIGHTING_MENU_VISIBILITY:
            return {
                ...state,
                lightingMenuVisibility: action.lightingMenuVisibility
            }
        case SET_ENABLE_RECORDING_MODAL:
            return {
                ...state,
                enableRecordingModal: action.enableRecordingModal
            }
        case SET_ENABLE_WEBJAM_MODAL:
            return {
                ...state,
                enableWebjamModal: action.enableWebjamModal
            }
        case SET_DISABLE_REC_ICON:
            return {
                ...state,
                disableRecIcon: action.disableRecIcon,
                recordingInitiator: action.recordingInitiator
            }
        case SET_SHOW_CONNECT_POPUP:
            return {
                ...state,
                showConnectPopup: action.showConnectPopup
            }
        case SET_STRIPE_ACCOUNT_REQUEST:
            return {
                ...state,
                isStripeRequesting: action.isStripeRequesting
            }
        case SET_DUET_USER_ID:
            return {
                ...state,
                duetUserId: action.duetUserId
            }
        case SET_STATE_MODEL:
            return {
                ...state,
                toolModal: action.toolModal
            }
        case SET_PREJOIN_SCREEN_DEVICE_INIT:
            return {
                ...state,
                prejoinDeviceConnection: action.prejoinDeviceConnection,
                remoteDeviceId: action.remoteDeviceId,
            }
        case SET_DO_HANG_UP:
            return {
                ...state,
                doHangUpRec: action.doHangUpRec
            }
        case SET_THIRD_PARTY_MOD_EVENT:
            return {
                ...state,
                thirdPartyModEvent: action.thirdPartyModEvent
            }
        case SET_DEVICE_INFO_MESSAGE:
            return {
                ...state,
                deviceInfoMessages: action.deviceInfoMessages,
                myRegisterDevice: action.myRegisterDevice
            }
        case SET_PREJOIN_ROOM_RT:
            return {
                ...state,
                prejoinScreenDetail: action.prejoinScreenDetail
            }
        case SET_HOST_BUTTON_ACTION:
            return {
                ...state,
                hostButtonAction: action.hostButtonAction
            }
        case SET_OUT_AUTO_MANAGE:
            return {
                ...state,
                outAutoManage: action.outAutoManage
            }
        case SET_REG_DEVICES:
            return {
                ...state,
                registeredDevice: action.registeredDevice,
                allUserDevices: action.allUserDevices
            }
        case SET_AVAILABLE_USER_IP:
            return {
                ...state,
                availableUserIp: [...state.availableUserIp, ...action.availableUserIp]
            }
        case SET_CUSTOM_TOUR_ACTION:
            return {
                ...state,
                customTourAction: action.customTourAction
            }
        case SET_DETECT_DEVICE_TIMER:
            return {
                ...state,
                detectDeviceTimer: action.detectDeviceTimer
            }
        case SET_JOIN_WITHOUT_DEVICE:
            return {
                ...state,
                joinRoomWithoutDevice: action.joinRoomWithoutDevice
            }

        case SET_BROWSER_DEVICE_STATUS:
            return {
                ...state,
                browserDeviceStatus: action.browserDeviceStatus
            }
        case SET_PREJOIN_SCREEN_STEP_FLAG:
            return {
                ...state,
                prejoinStepFlag: action.prejoinStepFlag
            }
        case SET_MEDIA_DEVICE_OVERLAY:
            return {
                ...state,
                mediaDeviceOverlay: action.mediaDeviceOverlay
            }
        case SET_PREJOIN_SOCK_WAIT:
            return {
                ...state,
                socketDeviceWaiting: action.socketDeviceWaiting
            }

        case SET_DEVICE_DETECTING:
            return {
                ...state,
                isUserDeviceDetecting: action.isUserDeviceDetecting
            }
        case SET_ZENDESK_STATE:
            return {
                ...state,
                isZendeskOpen: action.isZendeskOpen
            }
        case SET_MIXER_SETTINGS:
            return {
                ...state,
                isShowMixerSettings: action.isShowMixerSettings
            }
    }

    return state;
});